import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from "react-router-dom";

import Login from "./routes/Login/Login";
import Logout from "./routes/Logout/Logout";
import VerifyEmail from "./routes/VerifyEmail/VerifyEmail";
import ResetPassword from './routes/ResetPassword/ResetPassword';
import ChooseNewPassword from './routes/ChooseNewPassword/ChooseNewPassword';

import Account from "./routes/Account/Account";

import Register from "./routes/Register/Register";
import DogOwner from "./routes/Register/DogOwner/DogOwner";
import KennelClub from "./routes/Register/KennelClub/KennelClub";

import Events from "./routes/Events/Events";
import Event from "./routes/Event/Event";
import EventRegister from "./routes/EventRegister/EventRegister";
import EventManage from "./routes/EventManage/EventManage";
import PrivacyPolicy from "./routes/PrivacyPolicy/PrivacyPolicy";
import TermsOfService from "./routes/TermsOfService/TermsOfService";

import NotFound from "./routes/NotFound/NotFound";
import Header from "./components/Header/Header";
import IntercomWidget from "./components/Intercom/Intercom";

import { ModuleRegistry } from "ag-grid-community";
import { AllEnterpriseModule, LicenseManager } from "ag-grid-enterprise";
import './App.css';

function App() {
  const location = useLocation();
  const [locationStyle, setLocationStyle] = useState<string>();

  ModuleRegistry.registerModules([AllEnterpriseModule]);
  LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-073985}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Eager_Dog}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Eager_Dog}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Eager_Dog}_need_to_be_licensed___{Eager_Dog}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{18_December_2025}____[v3]_[01]_MTc2NjAxNjAwMDAwMA==c21f46ae2d9923cd681b6f93796380ae");

  const hiddenHeaderLocations:string[] = [
    "/login",
    "/register",
    "/register/kennel-club",
    "/register/dog-owner"
  ];

  useEffect(() => {
    document.body.style.overflow = 'unset';
    let _locationStyle = location.pathname.split("/");

    if (_locationStyle.length > 1 && _locationStyle[1].length > 0) {
      setLocationStyle(_locationStyle[1].toLowerCase() + "Page");
    } else {
      setLocationStyle("homePage");
    }

  }, [location.pathname]);

  return (
    <div className={hiddenHeaderLocations.includes(location.pathname) ? "Eagerdog noHeader " + locationStyle : "Eagerdog " + locationStyle}>
      <Header />
      <Routes>
        <Route path="/" element={<Events />} />
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/register/dog-owner" element={<DogOwner />} />
        <Route path="/register/kennel-club" element={<KennelClub />} />
        <Route path="/send-code" element={<ResetPassword />} />
        <Route path="/reset-password" element={<ChooseNewPassword />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/e/:eid" element={<Event />} />
        <Route path="/e/:eid/register" element={<EventRegister />} />
        <Route path="/e/:eid/manage" element={<EventManage />} />
        <Route path="/account" element={<Account />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path='*' element={<NotFound />}/>
      </Routes>
      <IntercomWidget />
    </div>
  );
}

export default App;